// your-zustand-store.js
import create from "zustand";

const useStore = create((set) => ({
  isOpen: true, 
  

  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export { useStore };
